import { RequestService } from '../request';

import { ICreatePushNotificationToken, IPushNotificationToken } from './push-notification.contract';

export class PushNotificationService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  async registerToken(data: ICreatePushNotificationToken) {
    return this.poster<IPushNotificationToken, ICreatePushNotificationToken>(
      `/push-notifications/register-token`,
      data
    );
  }

  async deactivateToken(deviceId: string) {
    return this.deleter(`/push-notifications/deactivate-token/${deviceId}`);
  }
}
